var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"ads-lead-form_index\"\u003E\u003CAdsLeadFormTable :data=\"data\" :meta=\"meta\" @load-data=\"loadData\"\u003E\u003C\u002FAdsLeadFormTable\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;